<ng-container *ngIf="!isLoading">

    <ng-container *ngIf="showLinkedInLoader && !isMobile">
        <div [@fadeIn] class="main-container d-flex justify-content-center align-items-center" [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')'}">
            <div class="linkedin-loader-container">
                <app-linkedin-loader></app-linkedin-loader>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="false">
        <div [@fadeIn] class="main-container d-flex justify-content-center align-items-center" [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')'}">
            <div class="options-content-container">
                <div class="options-container equal-section">
                    <div class="options-title mb-4">How would you like to create your card?</div>
                    <div class="options-body-container">
                        <button class="primary-form-btn" (click)="goToEnterDetails()">Enter Details</button>
                        <button class="secondary-btn" (click)="goToScanCard()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                <g clip-path="url(#clip0_1988_7875)">
                                    <path d="M12.32 2.90667L11.0467 1H5.95333L4.68 2.90667H1.5V15H15.5V2.90667H12.32Z" stroke="#0C0D10" stroke-width="1.5" stroke-miterlimit="10"/>
                                    <path d="M8.49969 12.4535C10.6094 12.4535 12.3197 10.7432 12.3197 8.63348C12.3197 6.52375 10.6094 4.81348 8.49969 4.81348C6.38996 4.81348 4.67969 6.52375 4.67969 8.63348C4.67969 10.7432 6.38996 12.4535 8.49969 12.4535Z" stroke="#0C0D10" stroke-width="1.5" stroke-miterlimit="10"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1988_7875">
                                        <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            Scan My Card
                        </button>
                        <button class="linkedin-btn" (click)="signUpWithLinkedIn()">
                            <img src="/assets/img/dbc-onboard-v2/linkedin-icon.svg" alt="LinkedIn" width="16" height="17" />
                            Continue with LinkedIn
                        </button>
                    </div>
                </div>

                <div class="preview-img-container equal-section d-flex justify-content-center align-items-center">
                    <img src="assets/cards-onboarding.gif" class="h-100">
                </div>

            </div>
        </div>
    </ng-container>



    <ng-container>
        <div [@fadeIn] [ngClass]="{'d-none': currentScreen !== SCREENS.ONBOARDING_FORM}">
            <app-dbc-desktop-form *ngIf="!isMobile"
                              [dbc]="dbc"
                              (inputValueChange)="onInputValueChange($event)"
                              (onCountryFlagChange)="onCountryChange($event)"
                              [fullPhoneNumber]="dbc?.phone_v2?.length > 0 && dbc.phone_v2[0]?.value ? dbc.phone_v2[0].value : ''"
                              [phoneNumber]="phoneNumber"
                              [countryNameCode]="countryNameCode"
                              [colorOptions]="colorOptions"
                              (imageSelected)="handleImageUpload($event)"
                              (onSaveCardClicked)="onSaveCard()"
                              [userImageUrl]="userImageUrl"
                              [logoUrl]="logoUrl"
                              [isFirstNameMissing]="isFirstNameMissing"
                              [isInvalidEmail]="isInvalidEmail"
                              [defaultColorPickerBackground]="defaultColorPickerBackground"
                              [layoutPrimaryColor]="layoutPrimaryColor"
                              (openEditImageModal)="handleOpenEditImageModal($event)"
                              [showSaveLoader]="showSaveLoader"
                              [emailInputErrorMessage]="emailInputErrorMessage"
            ></app-dbc-desktop-form>
            <app-dbc-mobile-form *ngIf="isMobile"
                                 [dbc]="dbc"
                                 (inputValueChange)="onInputValueChange($event)"
                                 (onCountryFlagChange)="onCountryChange($event)"
                                 [fullPhoneNumber]="dbc?.phone_v2?.length > 0 && dbc.phone_v2[0]?.value ? dbc.phone_v2[0].value : ''"
                                 [phoneNumber]="phoneNumber"
                                 [countryNameCode]="countryNameCode"
                                 [userImageUrl]="userImageUrl"
                                 [logoUrl]="logoUrl"
                                 [colorOptions]="colorOptions"
                                 (imageSelected)="handleImageUpload($event)"
                             (onSaveCardClicked)="onSaveCard()"
                             [isFirstNameMissing]="isFirstNameMissing"
                             [isInvalidEmail]="isInvalidEmail"
                             [defaultColorPickerBackground]="defaultColorPickerBackground"
                             [layoutPrimaryColor]="layoutPrimaryColor"
                             (openEditImageModal)="handleOpenEditImageModal($event)"
                             [showSaveLoader]="showSaveLoader"
                             [emailInputErrorMessage]="emailInputErrorMessage"
            ></app-dbc-mobile-form>
        </div>

        <div [@fadeIn] *ngIf="currentScreen === SCREENS.SCAN_CARD">
            <app-image-capture
                (closeScreen)="switchScreen(SCREENS.ONBOARDING_FORM)"
                (onBackBtnEmitter)="showCardCreationOptions()"
                (summarizeDataEmitter)="onSummarizeDataReceive($event)"
                (onScanErrorEmitter) = "onScanError()"
            ></app-image-capture>
        </div>

        <div [@fadeIn] [ngClass]="{'d-none': currentScreen !== SCREENS.LINKEDIN_LOADER}">
            <div class="linkedin-loader-mobile-container">
                <app-linkedin-loader></app-linkedin-loader>
            </div>
        </div>

        <div [@fadeIn] *ngIf="isCropperVisible">
            <app-image-cropper-v2 [imageFile]="selectedImageFile"
                                  (imageUpdated)="onCroppedImage($event)"
                                  (cropperClose)="closeCropper()">
            </app-image-cropper-v2>
        </div>
    </ng-container>
</ng-container>

<beaconstac-wait-loader [ngClass]="isLoading ? '' : 'd-none'" class="h-100 beaconstac-overlay full-layout"></beaconstac-wait-loader>

<div *ngIf="showEditImageModal" [@fadeIn]>
    <app-edit-image (removePhotoEmitter)="onRemovePhoto()" (changePhotoEmitter)="onChangePhoto()" (closeModalEmitter)="onCloseEditPhotoModal()" [imgSrc]="editImageSrc" [title]="editImageTitle"></app-edit-image>
</div>

<beaconstac-mobile-drawer
    [isDrawerOpen]="false"
    (onOutsideClick)="goToEnterDetails()"
>
    <div class="d-flex flex-column justify-content-center">
        <h1 class="card-create-title">How would you like to create your card?</h1>

        <div class="card-create-btn-container">
            <button class="primary-form-btn" (click)="goToEnterDetails()">Enter Details</button>
            <button class="secondary-btn" (click)="goToScanCard()">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clip-path="url(#clip0_1988_7875)">
                        <path d="M12.32 2.90667L11.0467 1H5.95333L4.68 2.90667H1.5V15H15.5V2.90667H12.32Z" stroke="#0C0D10" stroke-width="1.5" stroke-miterlimit="10"/>
                        <path d="M8.49969 12.4535C10.6094 12.4535 12.3197 10.7432 12.3197 8.63348C12.3197 6.52375 10.6094 4.81348 8.49969 4.81348C6.38996 4.81348 4.67969 6.52375 4.67969 8.63348C4.67969 10.7432 6.38996 12.4535 8.49969 12.4535Z" stroke="#0C0D10" stroke-width="1.5" stroke-miterlimit="10"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_1988_7875">
                            <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                        </clipPath>
                    </defs>
                </svg>
                Scan My Card
            </button>
            <button class="linkedin-btn" (click)="signUpWithLinkedIn()">
                <img src="/assets/img/dbc-onboard-v2/linkedin-icon.svg" alt="LinkedIn" width="16" height="17" />
                Continue with LinkedIn
            </button>

        </div>
    </div>
</beaconstac-mobile-drawer>


<div *ngIf="showSuccessBottomToast" class="mobile-alert-container" [class.hide]="!showSuccessBottomToast">
    <div class="p-3">
        <div>
            <img
                src="/assets/img/dbc-onboard-v2/check-circle.svg"
                alt="Success"
                width="20"
                height="20"
            />
            <span class="ms-3 alert-text pl-2">
                Image processed successfully
            </span>
        </div>
    </div>
</div>

<div bsModal #upgradeFailModal="bs-modal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered payment-fail-modal" role="document">
        <div class="modal-content">

            <div class="modal-body p-4">
                <div class="d-flex flex-column justify-content-center">
                    <h1 class="payment-fail-title">Account Upgrade Failed</h1>
                    <div class="payment-fail-description">Your account upgrade was unsuccessful. Please try again.</div>

                    <div class="payment-btn-container">
                        <button class="primary-form-btn" (click)="onRetryPaymentClick()">Try Upgrading Again </button>
                        <button class="secondary-btn" (click)="closeUpgradeFailedModal()">Start For Free</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<app-toast #customToast></app-toast>

<div>
    <app-error-message-modal [@fadeIn] *ngIf="showFileSizeErrorModal"
        [showErrorMessageModal]="showFileSizeErrorModal"
        [errorTitle]="fileSizeErrorTitle"
        [errorSummary]="fileSizeErrorSummary"
        [primaryCtaText]="primaryCtaText"
        [secondaryCtaText]="secondaryCtaText"
        [imageSrc]="imageSrc"
        (onPrimaryCtaClicked)="handleErrorModalPrimaryCtaClick()"
        (onSecondaryCtaClicked)="handleErrorModalSecondaryCtaClick()"
    ></app-error-message-modal>

    <app-error-message-modal [@fadeIn] *ngIf="showSvgErrorModal"
        [showErrorMessageModal]="showSvgErrorModal"
        [errorTitle]="svgErrorTitle"
        [errorSummary]="svgErrorSummary"
        [primaryCtaText]="primaryCtaText"
        [secondaryCtaText]="secondaryCtaText"
        [imageSrc]="imageSrc"
        (onPrimaryCtaClicked)="handleErrorModalPrimaryCtaClick()"
        (onSecondaryCtaClicked)="handleErrorModalSecondaryCtaClick()"
    ></app-error-message-modal>
</div>
